import { RootStateOrAny, useSelector } from 'react-redux';
import { SystemNotificationResource } from 'util/resources/SystemNotification';

export const useEmployerProfileSystemNotifications = (): {
  systemNotifications: SystemNotificationResource[];
} => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const systemNotifications: SystemNotificationResource[] = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
    (state: RootStateOrAny) => state.employer.systemNotifications,
  );
  return { systemNotifications };
};
